export default __webpack_public_path__ + "images/onboarding/parent-mode-42b6b977dc17bc881bc88f4683a77857.png";